import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { PageHeader } from '@/components/ui-kit/PageBits';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from '@/components/ui/dialog';
import { toast } from 'sonner';
import { Plus } from 'lucide-react';

export default function TeacherExercises() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ title:'', description:'', fen:'', solution_moves:'', difficulty:'easy', points:10, explanation:'' });
  const load = () => api.get('/exercises').then(r => setItems(r.data));
  useEffect(() => { load(); }, []);
  const submit = async () => {
    try {
      await api.post('/exercises', {
        ...form, points: Number(form.points),
        solution_moves: form.solution_moves.split(/\s+/).filter(Boolean),
      });
      toast.success('Ejercicio creado');
      setOpen(false); load();
    } catch { toast.error('Error'); }
  };
  return (
    <div className="p-8 max-w-5xl mx-auto">
      <PageHeader title="Ejercicios" subtitle="Crea y administra tácticas"
        right={
          <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild>
              <Button data-testid="new-exercise-btn" className="rounded-full bg-blue-600 hover:bg-blue-700"><Plus className="w-4 h-4 mr-1"/>Nuevo</Button>
            </DialogTrigger>
            <DialogContent>
              <DialogHeader><DialogTitle>Crear ejercicio</DialogTitle></DialogHeader>
              <div className="space-y-3">
                <Input placeholder="Título" value={form.title} onChange={(e)=>setForm({...form,title:e.target.value})}/>
                <Textarea placeholder="Descripción" value={form.description} onChange={(e)=>setForm({...form,description:e.target.value})}/>
                <Input placeholder="FEN" className="font-mono" value={form.fen} onChange={(e)=>setForm({...form,fen:e.target.value})}/>
                <Input placeholder="Solución SAN (ej: Ra8# Rxd8)" className="font-mono" value={form.solution_moves} onChange={(e)=>setForm({...form,solution_moves:e.target.value})}/>
                <div className="grid grid-cols-2 gap-2">
                  <Input placeholder="Dificultad" value={form.difficulty} onChange={(e)=>setForm({...form,difficulty:e.target.value})}/>
                  <Input type="number" placeholder="Puntos" value={form.points} onChange={(e)=>setForm({...form,points:e.target.value})}/>
                </div>
                <Textarea placeholder="Explicación" value={form.explanation} onChange={(e)=>setForm({...form,explanation:e.target.value})}/>
              </div>
              <DialogFooter><Button onClick={submit}>Crear</Button></DialogFooter>
            </DialogContent>
          </Dialog>
        }
      />
      <div className="grid sm:grid-cols-2 gap-4">
        {items.map(e => (
          <div key={e.id} className="rounded-2xl bg-white border border-slate-200 p-5">
            <div className="font-display font-bold">{e.title}</div>
            <div className="text-xs uppercase tracking-widest text-slate-500 font-bold mt-1">{e.difficulty} · +{e.points} pts</div>
            <div className="text-sm text-slate-600 mt-2 line-clamp-2">{e.description}</div>
            <div className="font-mono text-xs text-slate-500 mt-2 truncate">{e.fen}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
